<template>
  <el-config-provider :locale="zhCn">
    <div class="mobile-app-shell">
      <div class="mobile-phone-viewport">
        <!-- Desktop Smartphone Mockup Notch Header -->
        <div class="mobile-status-notch">
          <span class="notch-time">{{ currentTime }}</span>
          <span class="notch-center">五常龙凤山核心示范基地</span>
          <div class="notch-icons">
            <span>5G</span>
            <span>📶</span>
            <span>🔋 100%</span>
          </div>
        </div>

        <!-- Scrollable Screen Content -->
        <div class="mobile-screen-content">
          <router-view v-slot="{ Component }">
            <transition name="page-fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </div>
    </div>
  </el-config-provider>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import zhCn from 'element-plus/es/locale/lang/zh-cn';

const currentTime = ref('09:41');

let timer: any = null;

onMounted(() => {
  const updateTime = () => {
    const d = new Date();
    const h = String(d.getHours()).padStart(2, '0');
    const m = String(d.getMinutes()).padStart(2, '0');
    currentTime.value = `${h}:${m}`;
  };
  updateTime();
  timer = setInterval(updateTime, 30000);
});

onUnmounted(() => {
  if (timer) clearInterval(timer);
});
</script>

<style>
/* Page transition */
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.page-fade-enter-from {
  opacity: 0;
  transform: translateX(10px);
}

.page-fade-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

.notch-icons {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
}

.notch-center {
  font-size: 10px;
  opacity: 0.85;
}
</style>
